// R2a implementer — PageShell 모듈 (GREEN).
//
// 표준 페이지 wrapper + 헤더 슬롯. 디폴트 다크 (data-theme="dark"),
// theme="light" 인터페이스로 라이트 스코프 활성. 옵션 a (단일 모듈 + theme prop).
//
// planner 명세 (PageShell.test.jsx 인터페이스):
//   <PageShell title="..." controls={...} theme="dark"|"light">
//     {children}
//   </PageShell>
//
// 외부 의존 0 (react-router-dom / 차트 / api 등 직접 import 금지).

import React from 'react';
import './PageShell.css';

const PageShell = ({ title, controls = null, theme = 'dark', children }) => {
  return (
    <div className="page-shell" data-theme={theme}>
      <div className="page-shell__header">
        <h1 className="page-shell__title">{title}</h1>
        {controls && <div className="page-shell__controls">{controls}</div>}
      </div>
      <div className="page-shell__body">{children}</div>
    </div>
  );
};

export default PageShell;
